import { type AxiosInstance } from "axios"

export type FakePatientConditionRequest = {
	treatmentCenterUuid: string
	consultantUserId: string
	conditionKey: string
	amount: number
}

export type PhinTestCaseData = {
	condition: string
	bodyPart: string
	testCaseName: string
	patientEmail: string
}

class PatientFakeClient {
	constructor(private axiosClient: AxiosInstance) {}

	public create = (request: FakePatientConditionRequest) =>
		this.axiosClient.post<void>("/api/admin/patient/fake/create", request)

	public phinTestCases = (request: { consultantEmail: string }) =>
		this.axiosClient.post<PhinTestCaseData[]>(
			"/api/admin/patient/fake/create/phin",
			request
		)
}

export default PatientFakeClient
